module.exports = __webpack_public_path__ + "static/media/dc-artical3.f9ab129f.jpg";